import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// B5: browser extension. /activate approves a device sign-in; the policy page is a Settings tab
// (nested under the admin layout in modules/admin/routes.tsx). Account → Devices is DevicesCard.
const pages = () => import('./extension-pages');

export const routes: RouteObject[] = [{ path: 'activate', lazy: page(pages, (m) => m.ActivatePage) }];
export const orgRoutes: RouteObject[] = [];

export const settingsRoutes: RouteObject[] = [{ path: 'extension', lazy: page(pages, (m) => m.ExtensionSettingsPage) }];
